import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    let request: HttpRequest<unknown>;

    if (req.url.startsWith('https://identity.lokos.in')) {
        request = req.clone({
            headers: req.headers
                .set('scope', 'openid profile email')
                .set('x-encrypted', 'true')
                .set('x-refresh', 'true')
                .set('x-kcv', 'identity')
                .set('Ocp-Apim-Subscription-Key', environment.keycloakOcpKey)
        });
    } else if (req.url.startsWith('https://admin.lokos.in/api') || req.url.startsWith('https://api.lokos.in/api')) {
        request = req.clone({
            headers: req.headers
                .set('x-refresh', 'true')
                .set('Ocp-Apim-Subscription-Key', environment.adminSubscriptionKey)
        });
    } else if (req.url.startsWith('https://apis.lokos.in/profiles')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('Ocp-Apim-Subscription-Key', environment.clfSubscriptionKey)
        });
    } else if (req.url.startsWith('https://apis.lokos.in/search')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('Ocp-Apim-Subscription-Key', environment.keycloakOcpKey)
        });
    } else if (req.url.startsWith('https://apis.lokos.in/vault')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('Ocp-Apim-Subscription-Key', 'b09d4f667e604ebba5b3de0da9ab896f')
        });
    } else if (req.url.startsWith(environment.fdmTransactionsUrl)) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('Ocp-Apim-Subscription-Key', environment.cadreSubscriptionKey)
        });
    } else if (req.url.includes('/api/vault/ifc/')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'identity')
                .set('Ocp-Apim-Subscription-Key', environment.ifcSubscriptionKey)
        });
    } else if (req.url.includes('/api/ifc-')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('Ocp-Apim-Subscription-Key', environment.ifcSubscriptionKey)
        });
    } else if (req.url.includes('/api/vault/')) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'identity')
                .set('Ocp-Apim-Subscription-Key', environment.sheLeapsSubscriptionKey)
        });
    } else if (
        req.url.includes('/api/pe-') ||
        req.url.includes('/api/eep/') ||
        req.url.includes('/api/eeb/') ||
        req.url.includes('/api/agey-proposal/') ||
        req.url.includes('/api/agey-vehicles/') ||
        req.url.includes('/api/chc-') ||
        req.url.includes('/api/incubator-program/') ||
        req.url.includes('/api/ince-evaluation/') ||
        req.url.includes('/api/incubator-challenge/') ||
        req.url.includes('/api/pmfme')
    ) {
        request = req.clone({
            headers: req.headers.set('Ocp-Apim-Subscription-Key', environment.sheLeapsSubscriptionKey)
        });
    } else if (req.url.startsWith(environment.cadreProfileReport)) {
        request = req.clone({
            headers: req.headers
                .set('x-kcv', 'secure-identity')
                .set('x-refresh', 'true')
                .set('Ocp-Apim-Subscription-Key', environment.cadreSubscriptionKey)
        });
    } else {
        request = req.clone({
            headers: req.headers.set('Ocp-Apim-Subscription-Key', environment.subscriptionKey)
        });
    }

    return next(request);
};
